<template>
    <v-modal-validated title="Editar información de la entidad"
                       accept-button-text="Guardar"
                       close-button-text="Cerrar"
                       id="edit_entities_modal"
                       size="xl"
                       :rules="rules"
                       v-if="rules_loaded"
                       @closed="closeModal"
                       @accepted="editEntity">
        <div class="form-container">
            <div class="user-form row">
                <div class="form-group col-5">
                    <label>NIF*:</label>
                    <Field type="text" name="nif" class="form-control" v-model="entity.nif"/>

                    <ErrorMessage name="nif"/>
                </div>

                <div class="form-group col-7">
                    <label>Nombre corto*:</label>
                    <Field type="text" name="short_name" class="form-control" v-model="entity.short_name"/>

                    <ErrorMessage name="short_name"/>
                </div>
            </div>

            <div class="user-form row">
                <div class="form-group col-12">
                    <label>Nombre*:</label>
                    <Field type="text" name="name" class="form-control" ref="email" v-model="entity.name"/>

                    <ErrorMessage name="name"/>
                </div>
            </div>

            <div class="user-form row">
                <div class="more-fields row" id="more_fields">
                    <div class="form-group" :class="field.class" v-for="field in fields">
                        <label>{{ field.display_name }}{{
                                !!field.rules && isRequired(field.rules) === true ? '*' : null
                            }}</label>
                        <Field :type="field.type" class="form-control"
                               :list="field.datalist ? field.datalist : null"
                               :name="field.name"
                               :disabled="field.disabled === true ? true : null"
                               v-if="field.name !== 'town'"
                               v-model="entity[field.name]"/>

                        <Field id="town_datalist" :name="field.name" v-if="field.name === 'town'"  class="form-control" v-model="entity[field.name]">
                            <v-select-jq
                                class="form-select"
                                parent-id="edit_entities_modal"
                                :options="townsOptions"
                                placeholder="- Seleccionar -"
                                :modelValue="entity[field.name] + ' (' + entity['province'] + ')'"
                                :value="entity[field.name] + ' (' + entity['province'] + ')'"
                                @update:modelValue="townUpdated($event)">
                            </v-select-jq>
                        </Field>

                        <datalist id="type_road_datalist" v-if="field.name === 'type_road'">
                            <option :value="element" v-for="element in forms_help.road_types">{{ element }}</option>
                        </datalist>

                        <ErrorMessage :name="field.name"/>
                    </div>
                </div>
            </div>
        </div>

    </v-modal-validated>
</template>

<script>
import {getCCAAs, getProvinces, getRoadTypes, getTowns} from "../../../helpers/DataHelper";
import {editEntity} from "../../../helpers/requests/RequestsEntities";
import VModalValidated from "../../general/VModalValidated";
import {ErrorMessage, Field, Form} from "vee-validate";
import * as yup from "yup";
import {addRule, isRequired} from "../../../helpers/form";
import VSelectJq from "../../general/VSelectJQ";

export default {
    name: "EntititesListEditModal",
    components: {VModalValidated, Form, Field, ErrorMessage, VSelectJq},
    props: {
        entity: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            fields: [],
            rules_loaded: false,

            townsOptions: [],

            forms_help: {
                ccaas: getCCAAs(),
                provinces: getProvinces(),
                towns: getTowns(),
                road_types: getRoadTypes(),
            },

            rules: {
                nif: yup.string().required('Debes incluir el NIF de la entidad').max(50, 'Debe tener como máximo 50 caracteres'),
                short_name: yup.string().required('Debes incluir un nombre corto').max(50, 'Debe tener como máximo 50 caracteres'),
                name: yup.string().required('Debes incluir un nombre').max(50, 'Debe tener como máximo 50 caracteres'),
            }
        }
    },
    setup() {
        return {
            isRequired,
        }
    },
    mounted() {
        this.fields = require('../../../config/form_fields.json').entities;

        this.rules_loaded = true;

        for (let i in this.fields) {
            let field = this.fields[i];
            let add = yup;

            for (let j in field.rules) {
                let rule = field.rules[j];

                let name = rule.name;
                let message = rule.message;
                add = addRule(add, name, message);
            }

            this.rules[field.name] = add;
        }

        this.rules = yup.object(this.rules);

        let array = Object.keys(this.forms_help.towns);
        for (let i in array) {
            let town = array[i];
            this.townsOptions.push({id: town, text: town,});
        }
    },
    methods: {
        async editEntity(data) {
            try {
                data.id = this.entity.id;

                await editEntity(data);

                this.$store.dispatch('app/setToastMessage', 'Cambios guardados con éxito');

                this.closeModal();

            } catch (e) {
                this.$store.dispatch('app/setErrorToastMessage', 'Error al guardar los cambios');
            }
        },
        townUpdated(town) {
            if (this.forms_help.towns[town] !== undefined) {
                let location = this.forms_help.towns[town];
                // set ccaa | province
                this.entity['town'] = location.town;
                this.entity['community'] = location.ccaa;
                this.entity['province'] = location.province;
            }
        },
        closeModal() {
            this.$emit('closed');
        }
    }
}
</script>
